export const mapContactDto = (dto) => ({
    id: dto.id,
    name: dto.name,
    position: dto.position,
    eMail: dto.email,
    mobileNumber: dto.mobile_number,
    phoneNumber: dto.phone_number,
    companyId: dto.company_id,
    details: dto.details,
    companyName: dto.company_name,
});
